// eslint-disable-next-line max-classes-per-file
import moment from "moment";

let unique = 1;

export class Shift {
    constructor(shift) {
        unique += 1;
        this.unique = unique;
        this.type = shift.type;
        this.fromTime = moment(shift.fromTime, "HH:mm").format("HH:mm");
        this.toTime = moment(shift.toTime, "HH:mm").format("HH:mm");

        const from = moment(this.fromTime, "HH:mm");
        const to = moment(this.toTime, "HH:mm");

        this.from = from;
        this.to = to;

        let diff = to.diff(from, "minutes");
        if (diff < 0) diff = 24 * 60 + diff;

        this.duration = diff;
    }

    isSame(shift2) {
        if (!shift2) return false;
        if (this.type !== shift2.type) return false;
        if (this.fromTime !== shift2.fromTime) return false;
        return this.toTime === shift2.toTime;
    }
}

export class Day {
    constructor(config) {
        this.date = config.date;
        this.shifts = config.shifts;

        this.dayShifts = this.shifts.filter((s) => s.type === "day");
        this.nightShifts = this.shifts.filter((s) => s.type === "night");

        this.hasDayShift = this.dayShifts.length;
        this.hasNightShift = this.nightShifts.length;

        this.shiftsCount = (this.hasDayShift ? 1 : 0) + (this.hasNightShift ? 1 : 0);

        this.dayShiftsDuration = this.countTotalDuration(this.dayShifts);
        this.nightShiftsDuration = this.countTotalDuration(this.nightShifts);
        this.shiftsDuration = this.dayShiftsDuration + this.nightShiftsDuration;

        this.dayTime = this.countDurationInHours(this.dayShiftsDuration);
        this.nightTime = this.countDurationInHours(this.nightShiftsDuration);
        this.totalTime = this.countDurationInHours(this.dayShiftsDuration + this.nightShiftsDuration);
    }

    // eslint-disable-next-line class-methods-use-this
    countTotalDuration(shifts) {
        return shifts.reduce((acc, s) => acc + s.duration, 0);
    }

    // eslint-disable-next-line class-methods-use-this
    countDurationInHours(min) {
        return Math.floor((min / 60) * 10) / 10;
    }

    isSame(day) {
        if (this.shiftsCount !== day.shiftsCount) return false;
        if (this.shifts.length !== day.shifts.length) return false;
        if (this.shiftsDuration !== day.shiftsDuration) return false;

        const shifts1 = [...this.shifts];
        const shifts2 = [...day.shifts];

        while (shifts1.length) {
            const shift = shifts1.pop();
            const identicalShift = shifts2.findIndex((s) => s.isSame(shift));
            if (identicalShift === -1) return false;
            shifts2.splice(identicalShift, 1);
        }

        return !shifts2.length;
    }
}

export class CalculatedDay {
    constructor(date, calculations) {
        unique += 1;
        this.unique = unique;

        this.date = moment(date, "YYYY-MM-DD").format("YYYY-MM-DD");
        const formattedDate = moment(date, "YYYY-MM-DD").format("DD.MM.YYYY");
        this.shifts = [];

        calculations.forEach((c) => {
            c.intervals.forEach((i) => {
                const shift = new Shift({
                    fromTime: moment(i.from_time, "YYYY-MM-DD HH:mm:ss").format("HH:mm:ss"),
                    toTime: moment(i.to_time, "YYYY-MM-DD HH:mm:ss").format("HH:mm:ss"),
                    type: c.smena.toString() === "1" ? "day" : "night",
                });
                shift.calcId = c.calc_id;
                shift.date = formattedDate;
                this.shifts.push(shift);
            });
        });

        this.dayShifts = this.shifts.filter((s) => s.type === "day");
        this.nightShifts = this.shifts.filter((s) => s.type === "night");

        this.hasDayShift = this.dayShifts.length;
        this.hasNightShift = this.nightShifts.length;

        this.shiftsCount = (this.hasDayShift ? 1 : 0) + (this.hasNightShift ? 1 : 0);

        this.dayShiftsDuration = this.countTotalDuration(this.dayShifts);
        this.nightShiftsDuration = this.countTotalDuration(this.nightShifts);
        this.shiftsDuration = this.dayShiftsDuration + this.nightShiftsDuration;

        this.dayTime = this.countDurationInHours(this.dayShiftsDuration);
        this.nightTime = this.countDurationInHours(this.nightShiftsDuration);
        this.totalTime = this.countDurationInHours(this.dayShiftsDuration + this.nightShiftsDuration);
    }

    // eslint-disable-next-line class-methods-use-this
    countTotalDuration(shifts) {
        return shifts.reduce((acc, s) => acc + s.duration, 0);
    }

    // eslint-disable-next-line class-methods-use-this
    countDurationInHours(min) {
        return Math.floor((min / 60) * 10) / 10;
    }
}
